import { motion } from 'framer-motion';
import { Cloud } from 'lucide-react';

const CloudInfra = () => {
  const services = [
    { 
      name: 'Cloud Server Setup & Deployment', 
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80',
      features: ['AWS/Azure/GCP Setup', 'Server Configuration', 'Deployment Automation', 'Monitoring Setup']
    },
    { 
      name: 'DevOps & CI/CD Implementation', 
      image: 'https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=800&q=80',
      features: ['Pipeline Setup', 'Automated Testing', 'Continuous Deployment', 'Version Control']
    },
    { 
      name: 'Database & Security', 
      image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80',
      features: ['Database Optimization', 'Security Hardening', 'Firewall Setup', 'Backup & Recovery']
    },
  ];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
          <Cloud className="w-16 h-16 mx-auto mb-6 text-neon-blue" />
          <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-neon-purple to-neon-blue bg-clip-text text-transparent">
            Cloud Infrastructure
          </h1>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            We design and deploy secure, scalable, and high-performance cloud infrastructure tailored to modern businesses.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 isolate">
          {services.map((service, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.2 }}
              className="glass-morphism rounded-2xl overflow-hidden transition-all">
              <div className="h-48 overflow-hidden">
                <img src={service.image} alt={service.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-4 text-neon-purple">{service.name}</h3>
                <ul className="space-y-2">
                  {service.features.map((feature, j) => (
                    <li key={j} className="text-text-secondary flex items-start gap-2">
                      <span className="text-neon-blue mt-1">▹</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CloudInfra;

